import { render, staticRenderFns } from "./CarsView.vue?vue&type=template&id=9fda48c0"
import script from "./CarsView.vue?vue&type=script&lang=js"
export * from "./CarsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports